export default __webpack_public_path__ + "static/media/living-room4.2f9c70bc.jpg";